import * as Sentry from '@sentry/react'
import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'

const API_BASE: string = import.meta.env.VITE_API_BASE || ''

/** The app-wide query defaults; exported so tests run queries under the same policy. */
export const APP_QUERY_DEFAULTS = {
  staleTime: 1000 * 60 * 5, // 5 minutes
  refetchOnWindowFocus: false,
} as const

export const queryClient = new QueryClient({
  defaultOptions: { queries: APP_QUERY_DEFAULTS },
  queryCache: new QueryCache({ onError: (error: unknown) => Sentry.captureException(error) }),
  mutationCache: new MutationCache({ onError: (error: unknown) => Sentry.captureException(error) }),
})

export function buildAuthorizeUrl(provider: string): string {
  const origin = window.location.origin
  const base = API_BASE || ''
  const returnUrl = `${origin}/`
  return `${base}/v1/auth/oauth/${encodeURIComponent(provider)}?frontend_url=${encodeURIComponent(returnUrl)}`
}
